export default {
  admin: 'Admin',
  iin: 'iin',
  ecp: 'EDS',
  user_iin: 'user IIN',
  personnel_number: 'Personnel number',
  photo: 'Photography',
  photos: 'Photos',
  password: 'Password',
  login: 'Login',
  user_name: 'username',
  sign_in: 'Sign in',
  logout: 'Logout',
  main: 'Home',
  all_name: 'All {name}',
  optional: 'optional',
  date: 'Date',
  time: 'Time',
  login_for_auth: 'Login for authorization',
  password_for_auth: 'Password for authorization',
  min: 'min',
  type: 'Type',
  number: 'Number',
  accept_entire_region: 'Accept entire region',
  FIO_long: 'Last Name First Name',
  fio_small: 'full name',
  testing_started: 'Testing has begun',
  accept: 'Accept',
  reject: 'Reject',
  rejected: 'Rejected',
  user_fio: 'full name of the user',
  nomination: 'Name',
  nomination_plan: 'Plan name',
  nomination_theme: 'Topic title',
  nomination_test: 'Test name',
  nomination_package: 'Package name',
  nomination_exam: 'Exam name',
  nomination_webinar: 'Webinar Name',
  nomination_certificate: 'Certificate Name',
  nomination_audience: 'Audience name',
  nomination_file: 'File name',
  file: 'File',
  every_auth_date: 'dates of each authorization',
  registration_datetime: 'date and time of registration',
  list_attached_exams: 'list of attached exams',
  theme: 'Theme',
  exam_date: 'Exam date',
  theme_type: 'Theme type',
  theme_1: 'Theme',
  duration: 'Duration',
  duration_1: 'Duration',
  duration_2: 'Duration <br> <br>',
  condition_passing: 'Pass condition',
  condition_passing_test: '% correct answers (0 to 100%)',
  status: 'Status',
  materials: 'materials',
  educationPlan: 'Learning Plan',
  plan: 'plan',
  planName: 'Plan name',
  name: 'Title',
  name_1: 'Name',
  themeName: 'Theme name',
  new_exam: 'New exam',
  themes: 'Themes',
  verification_method: 'Verification method',
  subdivision: 'Division',
  subject: 'subject',
  certificate: 'Certificate',
  mew_certificate: 'New certificate',
  change_certificate: 'Change certificate',
  professions_list: 'List of professions',
  exam: 'Exam',
  download: 'Download',
  education_type: 'Type of training',
  education_plan_description: 'Description of the curriculum',
  short_description: 'Short description',
  education_type_1: 'Type of training',
  hour: 'hour | Hours | Hours',
  walkthrough: 'Walkthroughs',
  thematic_plan: 'Thematic plan',
  more: 'Details',
  check_type: 'Type of check',
  about_theme: 'About the topic',
  theme_info: 'Topic info',
  lesson_type: 'Lesson type',
  lesson_plan: 'Lesson plan',
  outline: 'Layout',
  benefits: 'Benefits',
  equipment: 'Equipment',
  about_test: 'About the test',
  test_info: 'Test information',
  conditions_passage: 'Passing conditions',
  industrial: 'Production',
  industrial_1: 'Production',
  theoretical: 'Theoretical',
  theoretical_1: 'Theoretical',
  exams_and_tests: 'Exams and tests',
  tests: 'Tests',
  new_test: 'New test',
  questions: 'Questions',
  question_text: 'Question text',
  retakes: 'Retake',
  retake_date: 'Retake Date',
  retake_time: 'Retake time',
  new_retake: 'New retake',
  description: 'Description',
  terms: 'Terms',
  question: 'Question | Question | Questions',
  test: 'Test | Test | Tests',
  results: 'Results',
  result: 'Result',
  passed: 'passed',
  average_result: 'The result is average',
  start_testing: 'Start testing',
  completed_exam: 'Completed the exam',
  testing: 'Testing',
  of: 'of',
  hrs: 'h',
  start_exam: 'Start exam',
  start: 'Start',
  exams: 'Exam',
  exams_ml: 'Exams',
  examiners: 'Examiners',
  completed: 'completed',
  complete_webinar: 'Complete webinar',
  share_screen: 'Share screen',
  off_share_screen: 'Turn off screen display',
  watch_now: 'Now watching',
  examiner: 'examiner',
  change_examiner: 'Change examiner',
  new_examiner: 'New examiner',
  examiner_fio: 'name of examiner',
  examiner_fio_1: 'Name of the host webinar',
  surname: 'Last name',
  examiner_surname: 'name of examiner',
  examiner_name: 'examiner name',
  examiner_middle_name: 'Middle name of the examiner',
  middle_name: 'Middle name',
  examiner_iin: 'examiner IIN',
  examiner_login: 'examiner login',
  examiner_password: 'examiner password',
  examiner_name_surname: 'Name of the examiner\'s last name',
  exam_start_date: 'Exam start date',
  passed_start_exam: 'Passed from the start of the exam',
  password_for_ecp: 'Password for EDS',
  report_card: 'Report card',
  sign_ecp: 'Sign EDS',
  admin_report_card: 'Admin sheet',
  analytic: 'Analytics',
  exam_analytic: 'Exam analytics',
  topics_wrong_answers: 'Wrong answers by topic',
  topics_right_answers: 'Correct answers to topics',
  current_webinars: 'Current webinars',
  all_webinars: 'All webinars',
  webinars: 'Webinars',
  webinar_date: 'Webinar Date',
  teacher_fullname: 'name of the person conducting',
  live_stream: 'Live Stream',
  watch_record: 'View Record',
  webinar_start_date: 'Webinar start date',
  start_date: 'Start date',
  webinar_beginner_time: 'It has been since the beginning of the webinar',
  until_webinar: 'Until the end of the webinar',
  ask_question: 'Ask a question',
  connect: 'Connect',
  coming_webinar: 'Upcoming Webinars',
  will_start: 'Starts through',
  camera: 'Camera',
  face_not_recognized: 'Face not recognized',
  cancel: 'Cancel',
  image: 'Image',
  important: 'Important',
  check_camera: ['Make sure the camera is working', 'Look straight at the camera', 'Wait while the system recognizes you'],
  past_webinar: 'Past webinars',
  scorm_package: 'Scorm packages',
  scorm_package_1: 'scorm package',
  not_passed: 'Not passed',
  run: 'Run',
  scormPackageIframe: 'Introductory course on labor protection, industrial safety and environmental protection',
  mediafiles: 'Media files',
  create_mediafile: 'New media file',
  change_mediafile: 'Change media file',
  prev: 'Back',
  next: 'Forward',
  remove: 'Remove',
  region: 'Region',
  exam_result: 'Exam results',
  question_count: 'Number of questions',
  test_duration: 'Test duration',
  webinar_duration: 'Duration of the webinar',
  minute: 'Minute | Minutes | Minutes',
  before_exam_end: 'Until the exam ends',
  complete_exam: 'Complete Exam',
  test_time_up: 'Test timed out!',
  testing_time: 'Testing time',
  ok: 'OK',
  webinar_testing_desc: 'Several tests may be conducted during the webinar',
  webinar_time: 'Webinar time',
  no_message: 'No posts yet',
  upload_file: 'Upload file',
  uploading: 'Uploading',
  write: 'Write',
  close: 'Close',
  webinar_chat: 'Webinar chat',
  webinar_name: 'Webinar Name',
  webinar_question_for: 'Webinar question for',
  send: 'send',
  answer: 'Answer',
  change_password: 'Change password',
  current_password: 'Current password',
  new_password: 'New password',
  repeat_new_password: 'Retype new password',
  password_mismatch: 'Passwords do not match',
  save: 'Save',
  statistics: 'Statistics',
  visits_log: 'Visit log',
  users: 'Users',
  create_webinar: 'Create webinar',
  create_webinar_1: 'Create a webinar',
  create: 'Create',
  webinar_teachers: 'Conducting a webinar',
  webinar: 'Webinar',
  webinar_questions: 'Webinar questions',
  admin_questions: 'Admin questions',
  certificates: 'Certificates',
  roles: 'Roles',
  audience_exam: 'Audience Exam',
  new_audience_exam: 'New exam audience',
  change_audience_exam: 'Change exam audience',
  audience: 'Audience',
  download_report: 'Download Report',
  course_attendance: 'Attendance at courses',
  test_turnout: 'Appearance for test',
  received_certification: 'Received certification',
  download_excel: 'Download Excel',
  education_theme: 'Learning topic',
  item_list: 'List of items',
  visit: 'Visit',
  education_times: 'hours of study',
  position: 'Position',
  position_1: 'Position',
  select_position: 'Select a position',
  user_type: 'User type',
  time_sheet: 'time sheet',
  auth_date: 'Date of authorization',
  retake: 'Retake',
  assign_retake: 'Assign re-assignment',
  assign_retakes_list: 'List of assigned re-assignments',
  assign: 'Assign',
  import_database: 'Import database',
  create_user: 'Create user',
  registration_date: 'Registration date',
  create_recording_webinar: 'Record a live webinar',
  change_recording_webinar: 'Changing the recording of a webinar conducting',
  webinar_started_through: 'Webinar can be started through',
  teacher_login: 'User login',
  availability_photo: 'Availability of photo',
  timetable: 'Schedule',
  user_photos: 'User photos',
  upload_photo: 'Upload Photos',
  upload: 'Upload',
  attach_plan: 'Attach a plan',
  attach: 'Attach',
  block: 'Block',
  unlock: 'Unlock',
  gradebook: 'Gradebook',
  hours_cnt: 'Number of hours',
  new_user: 'New user',
  change_webinar: 'Change webinar',
  max_upload: 'The file must not exceed {size}',
  max_upload_video: 'Video for preview {size}',
  size: {
    mb: 'megabytes'
  },
  export: 'Export',
  import: 'Import',
  create_plan: 'Create plan',
  change_plan: 'Change plan',
  change: 'Change',
  occupational_professions: 'Occupations passing the topic',
  themes_count: 'Number of themes',
  students: 'Learning',
  education_plan_name: 'Name of the curriculum',
  exam_type: 'exam type',
  new_theme: 'New topic',
  change_theme: 'Change topic',
  theme_number: 'Theme number',
  training_number: 'Sequence number in the training plan',
  serial_number: 'Sequence number',
  theme_description: 'Topic description',
  new_material_outline: 'Layout of the new material',
  list_equipment_used: 'List of equipment used',
  list_educational_aids: 'List of educational visual aids',
  count_hours_study: 'Number of training hours',
  test_relate_webinar: 'Test refers to a webinar',
  change_test: 'Change test',
  new_question: 'New question',
  change_question: 'Change question',
  possible_answer: 'Answer option',
  correct_answer: 'Correct answer',
  class_room: 'Class',
  change_retake: 'Change retake',
  update: 'Update',
  enter: 'Enter',
  exam_audience: 'Exam Audience',
  exam_time: 'exam time',
  change_exam: 'Change exam',
  day_locale: {
    'Mon': 'Mon',
    'Tue': 'Tue',
    'Wed': 'Wed',
    'Thu': 'Thu',
    'Fri': 'Fri',
    'Sat': 'Sat',
    'Sun': 'Sun'
  },
  month_locale: {
    'Jan': 'January',
    'Feb': 'February',
    'Mar': 'March',
    'Apr': 'April',
    'May': 'May',
    'Jun': 'June',
    'Jul': 'July',
    'Aug': 'August',
    'Sep': 'September',
    'Oct': 'October',
    'Nov': 'November',
    'Dec': 'December'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/en.js